import { registerMfModule } from 'src/store/base';
import list from './list';
import image from './library-image';
import video from './library-video';
import playable from './library-playable';
import playableCheck from './playable-check';

export default {
  namespaced: true,
  state: {
    _moduleKey: 'library',
  },
  modules: {
    list,
    image,
    video,
    playable,
    ...registerMfModule([playableCheck]),
  },
};
